module.exports = __webpack_public_path__ + "img/health-telemedicina-bg--disabled.4c416077.png";